import React from "react";
import {Button, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Loading from "../../common/Loading/Loading";
import "./CreateDialog.css";

class CreateDialog extends React.Component {
  renderFields = () => {
    return this.props.modalBodyFields.map(field => {
      return (
        <FormGroup className={`custom_form ${field.fieldClassName}`} key={field.id}>

            {field.inputType === "checkbox" && (
                <div><Label for={field.id}>{field.label}</Label>&nbsp;
                    <input type="checkbox"
                           name={field.id}
                           checked={field.newField !== undefined ? field.newField : false}
                           onChange={e => field.onChange(e)}/>
                </div>
            )}
            {field.newField !== null && field.inputType !== "checkbox" && (
                <Label for={field.id} className={field.isFieldInvalid ? "invalid" : ""}>
                    {field.label}
                </Label>
            )}
            {field.inputType !== "checkbox" && (
                <Input
                    type={field.inputType}
                    name={field.id}
                    id={field.id}
                    placeholder={field.label}
                    onChange={e => {
                        if (field.validateFieldName && field.validateFieldName !== 0) {
                            field.onChange(e, field.validateFieldName);
                        } else {
                            field.onChange(e);
                        }
                    }}
                    invalid={field.isFieldInvalid}
                    maxLength={field.maxLength || ""}
                    autoComplete="off"
                    value={field.newField !== undefined && field.newField !== "" ? field.newField : field.defaultValue}
                />
            )}
          <FormFeedback>
            {field.isFieldInvalid
              ? field.invalidFieldMessage !== "max_length"
                ? field.invalidFieldMessage
                : ""
              : "Required field"}
              valid="false"
          </FormFeedback>

          {field.maxLength && 
            <span className={field.isFieldInvalid ? "char-feedback-invalid" : "char-feedback"}>
              {`${field.newField !== null ? field.newField.length : 0}/${field.maxLength}`}
            </span>
          }
        </FormGroup>
      );
    });
  };
  render() {
    return (
      <div>
        <Modal isOpen={this.props.isModalVisible} size="lg">
          {!this.props.isDialogLoading ? (
            <ModalHeader
              toggle={() => {
                this.props.handleDialogToggle();
                if(this.props.cancelAction){
                  this.props.cancelAction();
                }
              }}
            >
              {this.props.modalHeaderName}
            </ModalHeader>
          ) : (
            <ModalHeader>{this.props.modalHeaderName}</ModalHeader>
          )}

          {!this.props.isDialogLoading && (
            <ModalBody>{this.renderFields()}</ModalBody>
          )}

          {this.props.isDialogLoading && (
            <ModalBody className="loading-body">
              <Loading />
            </ModalBody>
          )}

          <ModalFooter>
            <Button
              color="btn btn-link"
              onClick={() => {
                this.props.handleDialogToggle();
                if(this.props.cancelAction){
                  this.props.cancelAction();
                }
              }}
              disabled={this.props.isDialogLoading}
            >
              Cancel
            </Button>
            <Button
              type="button"
              className="btn btn-success submit-user-button"
              onClick={() => this.props.action()}
              disabled={this.props.isDialogLoading || this.props.modalBodyFields.filter(f => f.isFieldInvalid).length > 0}
            >
              Save
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default CreateDialog;



// WEBPACK FOOTER //
// ./src/common/CreateDialog/CreateDialog.js